module.exports = __webpack_public_path__ + "img/h01-min.80551aed.png";